<a
  class="help-article theme-color--on-hover"
  [href]="url()"
  target="_blank"
  data-ideals="helpArticle"
>
  @let _title = title();

  <span
    class="title"
    [ideals-tooltip]="_title"
    idealsOverflow
  >
    {{ _title }}
  </span>
  <i class="icon icons-open-link theme-color"></i>
</a>
